module.exports = __webpack_public_path__ + "img/dengji3.f2139481.png";